import PropTypes from 'prop-types';
import React from "react";
import Truncate from "../../../../components/truncate";
import cx from "classnames";
import TimeAgo from "react-timeago";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  // Panel,
  OverlayTrigger,
  Tooltip,
  AccordionCollapse,
  Accordion
  // Media,
} from "react-bootstrap";
import dateformat from "dateformat";
import { FileService }  from "src/services/file.service"
import SectionShareView from 'src/legacy/components/SectionShareView/SectionShareView.jsx';
import styles from './styles.module.scss';
import ContactAssetShareView from '../ContactAssetShareView';
import { localizedStrings } from '../../../../localization';
import AccordianHeader from '../components/AccordionHeader';
import _ from 'lodash';

class ContactShareView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadAnalytics: false,
    };

    this._handleShareClicked = this._handleShareClicked.bind(this);

    // localized contents
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedContacts = this.localizedCommons.sliders.contacts;
  }

  fetchAssetAnalytics(sectionID, asset) {
    this.props
      .fetchAssetAnalytics(
        this.props.contact,
        this.props.share.id,
        sectionID,
        asset.id
      )
      .then(() => {
        if (FileService.hasPageAnalytics(asset.metadata)) {
          if (this.props.preview && this.props.preview.item) {
            return;
          }

          this.props.fetchPreviewAsset(asset.id);
        }
      });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.id != nextProps.id) {
      this.setState({
        loadAnalytics: false,
      });
    }
  }

  _handleShareClicked() {
    if (this.props.share && this.props.share.fetchedChildren) {
      return;
    }

    this.props.fetchShareForContact(this.props.contact, this.props.id);
  }

  render() {
    if (!this.props.share) {
      return false;
    }

    var emailOpenEvent = null;
    var linkClickedEvent = null;
    var collectionViewedEvent = null;
    var collectionResharedEvent = null;

    if (this.props.share.events) {
      this.props.share.events.forEach((event) => {
        switch (event.type) {
          case "email_open":
            emailOpenEvent = event;
            break;
          case "link_clicked":
            linkClickedEvent = event;
            break;
          case "collection_viewed":
            collectionViewedEvent = event;
            break;
          case "collection_reshared":
            collectionResharedEvent = event;
          default:
            break;
        }
      });
    }

    var assetsCount = this.props.share.assetsCount;
    const viewEvent = this.getViewedEvent(this.props.share.events);
    const emailEvent = this.getEmailOpenEvent(this.props.share.events);

    var header = (
      <Row className={styles.share} >
        <Col md={8} className={styles.shareMetaData}>
              <div>
                <div className={styles.name}>
                  <Truncate lines={1} width={300}>{this.props.share.name || "(No Subject)"}</Truncate>
                </div>
              </div>
              <div className={styles.sharedDate}>
                <p>
                {localizedStrings.formatString(this.localizedContacts.shared_by, {
                    date:  <TimeAgo date={this.props.share.sharedDate} />
                  }
                  )}
                   {
                    this.props.share.source &&
                    <span className={styles.source} >{` ${this.props.share.createdBy && ` ${this.renderUserName(this.props.share.createdBy)}`}`}</span>
                  }
                </p>
                <span onClick={(e) => e.stopPropagation()}>
                <Link style={{textDecoration:"none"}} to={`/conversations/${_.get(this.props,"share.id")}`}><div className={styles.viewConversation}>
                <span>
                {this.localizedContacts.actions.view_conversation} 
                </span>
                <span className={styles.rightArrow}>
                <i className='paperflite-dropdown'></i>
                </span>
                </div>
                </Link>

                </span>
                </div> 
              <div className={styles.assetDescription}>
                <div className={styles.assetsCount}>{assetsCount} {this.localizedKeywords.asset}{assetsCount > 1 && 's'}</div>
                <div className={cx(styles.assetsCount, styles.shareSource)}>{this.props.share.source}</div>
              </div>
        </Col>
        <Col md={4} className={cx(styles.shareMetrics)}>
          {(this.props.share.totalTimeSpent > 0 &&
            <div className={cx(styles.metrics, styles.disabled)}>
              <span className={styles.timeSpent}>
                {this.timeSpentValue(this.props.share.totalTimeSpent)}
              </span>
            </div>
          )}

          <div
            className={cx(styles.metrics, {
              [cx(styles.disabled, "contact_row_share_metrics__disabled")]:
                !emailEvent,
            })}
          >
            {!emailEvent && <span className="paperflite-email-open">
              <i className='paperflite-mail-open'></i>

            </span>}

            {emailEvent && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip">
                    {this.localizedContacts.tooltip.opened_email_last_on}{" "}
                    {dateformat(emailEvent.createdDate, "dd mmm yyyy")}
                  </Tooltip>
                }
              >
                <span className="paperflite-email-open">
                <i className='paperflite-mail-open'></i>

                </span>
              </OverlayTrigger>
            )}
          </div>
          <div
            className={cx(styles.metrics, {
              [cx(styles.disabled, "contact_row_share_metrics__disabled")]:
                !viewEvent,
            })}
          >
            {!viewEvent && <span className="paperflite-click-rate"><i className='fa-regular fa-hand-pointer'></i></span>}

            {viewEvent && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip">
                    {this.localizedContacts.tooltip.last_clicked_on}{" "}
                    {dateformat(viewEvent.createdDate, "dd mmm yyyy")}
                  </Tooltip>
                }
              >
                <span className="paperflite-click-rate"><i className='fa-regular fa-hand-pointer'></i></span>
              </OverlayTrigger>
            )}
          </div>
          <div
            className={cx(styles.metrics, {
              [cx(styles.disabled, "contact_row_share_metrics__disabled")]:
                !collectionResharedEvent,
            })}
          >
            {!collectionResharedEvent && (
              <span className="paperflite-share"></span>
            )}

            {collectionResharedEvent && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip">
                    {localizedStrings.formatString(this.localizedContacts.tooltip.reshared, { count: collectionResharedEvent.count })}
                    {dateformat(
                      collectionResharedEvent.createdDate,
                      "dd mmm yyyy"
                    )}
                  </Tooltip>
                }
              >
                <span className="paperflite-share"></span>
              </OverlayTrigger>
            )}
          </div>
        </Col>
      </Row>
    );

    return (
      <Accordion>
        <AccordianHeader eventKey={this.props.share.id} onClick={()=>this._handleShareClicked()}>
        {header}
        </AccordianHeader>
        <AccordionCollapse eventKey={this.props.id}>
          <>
        {this._renderChildren()}
          </>
        </AccordionCollapse>
     
 
      </Accordion>
   

   
      // <h1>7</h1>
    );
  }

  isEventExists(events) {
    if (!events) {
      return null;
    }

    const viewEvents = events.filter(event => {
      return event.type === 'collection_viewed' || event.type === 'asset_viewed' || event.type === 'link_clicked' || event.type === 'email_open';
    }).sort((e1, e2) => {
      return e2.createdDate - e1.createdDate;
    })

    if (viewEvents.length > 0) {
      return viewEvents[0];
    }
  }

  getViewedEvent(events) {
    if (!events) {
      return null;
    }

    const viewEvents = events
      .filter((event) => {
        return (
          (event.type === "collection_viewed" || event.type === "asset_viewed" || event.type === "link_clicked") && event.exclusion === false
        ) && event.exclusion === false;
      })
      .sort((e1, e2) => {
        return e2.createdDate - e1.createdDate;
      });

    if (viewEvents.length > 0) {
      return viewEvents[0];
    }
  }

  getEmailOpenEvent(events) {
    if (!events) {
      return null;
    }

    const viewEvents = events
      .filter((event) => {
        const source = this.props.share.source;
        return (event.type === "email_open" || (event.type === "link_clicked" && source === "Paperflite QuickSend")) && event.exclusion === false;
      })
      .sort((e1, e2) => {
        return e2.createdDate - e1.createdDate;
      });

    if (viewEvents.length > 0) {
      return viewEvents[0];
    }
  }

  renderUserName(user) {
    if (user.id === _.get(this.props, "user.id")) {
      return "me";
    } else {
      return `${user.firstName || ""} ${user.lastName || ""}`;
    }
  }

  _renderChildren() {
    if (this.props.share.fetching) {
      return <div className={styles.loading}>{this.localizedContacts.loading.details}...</div>;
    }

    if (this.props.share.sections && this.props.share.sections.length > 0) {
      return this._renderSections();
    } else if (this.props.share.assets && this.props.share.assets.length > 0) {
      return this._renderAssets();
    }
  }

  _renderSections() {
    var sections = this.props.share.sections.map((section) => {
      return (
        // <AccordionCollapse eventKey={section.id} key={section.id}>
        <SectionShareView
          className={styles.section}
          key={section.id}
          section={section}
          renderWithin="contact"
          conversation={this.props.share}
          fetchShareSection={this.props.fetchShareSection}
          fetchAssetAnalytics={this.fetchAssetAnalytics.bind(this)}
        />
              //  </AccordionCollapse>
      );
    });

    return sections;
  }

  _renderAssets() {
    var assets = this.props.share.assets.map((asset) => {
      return (
        // <Accordion.Collapse eventKey={this.props.share.id} key={asset.id}>
        <ContactAssetShareView
          key={asset.id}
          className={styles.asset}
          asset={asset}
          renderWithin="contact"
          events={asset.events}
          shouldFetchAnalytics={true}
          fetchAssetAnalytics={this.fetchAssetAnalytics.bind(this)}
        />
        // </Accordion.Collapse>
      );
    });

    return assets;
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }
    return padding + number;
  }

  timeSpentValue(timeSpent) {
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    return timeSpentValue;
  }
}

export default ContactShareView;